import React, { useEffect, useState } from "react";
import { Euler, Vector3 } from "three";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";
import { ConfigurationProps } from "../../Door";
import Scharnier from "../../doors/scharnier";
import { mirrorVerticalBeamPosition } from "entities/configurator/model/layoutMeta";

export const nullRotation = new Euler(0, 0, 0);

interface DoubleScharnierProps extends ConfigurationProps {}
const DoubleScharnier: React.FC<DoubleScharnierProps> = ({
  materials,
  position,
  rotation,
  scale,
  doorSettings,
}: DoubleScharnierProps) => {
  const position0 = new Vector3(-0.495, 0, 0);
  // const position1 = new Vector3(0.459, 0, 0);
  const position1 = new Vector3(0.415, 0, 0);

  const {
    eigenwijs,
    getConfigurationPositions,
    isDoubleHandleChosen,
    isDoubleJHandle,
    sceneStaanderPosition,
  } = useConfigurationOptionsContext();

  const [positions, setPositions] = useState<Vector3[]>([]);

  useEffect(() => {
    setPositions(getConfigurationPositions([position0, position1]));
  }, [eigenwijs?.sizeObjects]);

  const primaryVerticalBeamPosition = mirrorVerticalBeamPosition(
    sceneStaanderPosition,
  );

  return (
    <group scale-y={0.98} position={position} scale={scale}>
      <Scharnier
        materials={materials}
        position={positions[0]}
        rotation={isDoubleHandleChosen ? nullRotation : rotation}
        secondary={true}
        index={0}
        kozijnSettings={doorSettings?.secondary?.kozijnSettings}
        frameSettings={doorSettings?.secondary?.frameSettings}
        lockSettings={doorSettings?.secondary?.lockSettings}
        secondaryDoorDoubleJHandle={isDoubleJHandle}
        verticalBeamPosition={sceneStaanderPosition}
      />
      <Scharnier
        materials={materials}
        position={positions[1]}
        index={1}
        kozijnSettings={doorSettings?.main?.kozijnSettings}
        frameSettings={doorSettings?.main?.frameSettings}
        lockSettings={doorSettings?.main?.lockSettings}
        verticalBeamPosition={primaryVerticalBeamPosition}
      />
    </group>
  );
};

export default DoubleScharnier;
